import { resetModalContent, setModalContent } from '../../slice';
import { Store } from '../../store';

export const resetAlertModal = () => {
    Store.dispatch(resetModalContent());
};

export const setAlertModal = obj => {
    Store.dispatch(setModalContent(obj));
};
